import { Dayjs } from 'dayjs'
import { useMemo } from 'react'

export const getDaysOfWeek = (date: Dayjs) => {
  const startOfWeek = date.day() === 0 ? date.subtract(6, 'day') : date.startOf('week').add(1, 'day')
  const daysOfWeek: Dayjs[] = []

  for (let i = 0; i < 7; i++) {
    const day = startOfWeek.add(i, 'day')
    daysOfWeek.push(day)
  }

  return daysOfWeek
}

export function useWeek(date: Dayjs) {
  return useMemo(() => getDaysOfWeek(date), [date])
}
